/**
 * Extract league display name from API match payload (used in pick history / match rows).
 */

import { BET_HISTORY_DISPLAY_FALLBACKS } from '../constants/challengeStatus.constants';

export function getLeagueNameFromMatchPayload(match: unknown): string {
  if (!match || typeof match !== 'object' || !('league' in (match as object))) {
    return BET_HISTORY_DISPLAY_FALLBACKS.UNKNOWN;
  }
  const m = match as Record<string, unknown>;
  const league = m.league;
  if (league && typeof league === 'object' && league !== null && 'name' in league) {
    return (league as { name?: string }).name ?? BET_HISTORY_DISPLAY_FALLBACKS.UNKNOWN;
  }
  return typeof league === 'string' ? league : String(league ?? BET_HISTORY_DISPLAY_FALLBACKS.UNKNOWN);
}
